const dialog = require('../../../../../components/dialog/dialog')

export function start(detail) {
  const body = dialogBody[detail.id]
  if (!body) return

  body.start(detail)
  dialog.start({ ...detail, html: body })
}

const dialogBody = {
  inventoryRestoreConflict: {
    title: '',
    des: '',
    bodyHtml: '',

    primary: {
      text: 'Close',
      class: 'button primary',
      dataDetail: `data-detail='{
        "click": [
          {"dest":"ripple"},
          {"dest":"dialog", "act":"hide"}
        ]
      }'`
    },

    secondary: {
      text: '',
      class: 'button secondary button-plain',
      dataDetail: ''
    },

    tertiary: {
      text: '',
      class: 'button secondary button-plain',
      dataDetail: ''
    },

    start(detail) {
      const items = Array.isArray(detail.items) ? detail.items : []

      this.title = 'Sale cannot be restored'
      this.des = 'The following items do not have enough current inventory for the net quantity in this sale.'
      this.bodyHtml = inventoryTable(items)
    }
  }
}

function inventoryTable(items) {
  const rows = items.map(item => `
    <tr>
      ${cell(item.purchase_code)}
      ${cell([item.item_code, item.item_name].filter(Boolean).join(' - '))}
      ${cell(item.selling_type)}
      ${cell(formatQuantity(item.restore_qty))}
      ${cell(formatQuantity(item.available_qty))}
      ${cell(formatQuantity(item.missing_qty))}
    </tr>
  `).join('')

  return `<div class="dt-simple-fullcont">
    <table class="behaivor-quickview-table">
      <thead>
        <tr>
          <th>Purchase</th>
          <th>Item</th>
          <th>Unit</th>
          <th>To Restore</th>
          <th>Available</th>
          <th>Missing</th>
        </tr>
      </thead>
      <tbody>${rows}</tbody>
    </table>
  </div>`
}

function cell(value) {
  const safeValue = escapeHtml(value)
  return `<td><div class="cell-data" title="${safeValue}"><span class="value-text">${safeValue}</span></div></td>`
}

function formatQuantity(value) {
  const quantity = Number(value)
  if (!Number.isFinite(quantity)) return '0'
  return Number.isInteger(quantity) ? String(quantity) : quantity.toFixed(2)
}

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}
